<unity-dialog-shared layout="start" width="90%" height="90%" [title]="undefined" (closeEvent)="onClose()">
  <ng-content dialog-body>
    <unity-survey-creator-accessor [formControl]="$control()" />
  </ng-content>
  <ng-content ngProjectAs="[dialog-actions]">
    <button kendoButton type="button" themeColor="primary" (click)="onClose()">Close</button>
  </ng-content>
</unity-dialog-shared>
